export const environment = {
  production: true,
  apiURL: 'https://prd1.athena.ushe-ords.io/api/v1',
  redirect_uri: 'https://prd1.athena.ushe-ords.io/auth/login',
  oAuthClientId: '621473761570-enmfulffu4urjqjuqhjqtsimlcbi6fqc.apps.googleusercontent.com',
};
